<template>
  <div class="coupon-item-w" :class="{ withoutCType: !coupon.couponTypeStr }">
    <div v-if="isBlackUser" class="c-type-b">黑金专享</div>
    <div else class="c-type">{{ getCouponTypeText }}</div>
    <div class="l">
      <div class="price-ctn number500">
        <span class="tag">&yen;</span
        ><span>{{ coupon.couponAmount / 100 }}</span>
      </div>
      <div class="mt8">
        {{
          +coupon.couponType === 2
            ? '无门槛使用'
            : `满${coupon.useAmountLimit / 100}使用`
        }}
      </div>
    </div>
    <div class="m" :class="{ hideRight }">
      <div
        class="coupon-name pf-medium ui-nowrap-multi"
        v-html="couponName"
      ></div>
      <div class="coupon-time mt8">
        <span>有效期：</span>{{ effectiveTime }}
      </div>
    </div>

    <!--兼容订单确认页优惠券样式-->
    <template v-if="!hideRight">
      <div class="r">
        <button v-if="checkBtnStatus" @click="getCoupon">
          <span>{{ btnText }}</span>
        </button>
      </div>
      <div v-if="receivedStatus" class="img-getted"></div>
      <div v-if="isFinished" class="img-snatched"></div>
    </template>
    <div v-else class="r" style="width: 0.6rem"></div>
  </div>
</template>
<script>
import { COUPON_RECEIVED_STATUS } from '@/config'
import { isNonEmptyArray, isNullOrEmpty } from '@/utils'
import { COUPON_CATEGORY_TYPES } from '@/business/coupon'
export default {
  props: {
    incoupon: Object,
    hideRight: Boolean
  },
  data() {
    return { coupon: this.incoupon, fetchStatus: false }
  },
  computed: {
    getCouponTypeText() {
      return COUPON_CATEGORY_TYPES.get(this.coupon.couponCategory)
    },
    isBlackUser() {
      return this.coupon.userType === 2
    },
    couponName() {
      // 文字和数字同事出现 数字不加粗
      return this.coupon.couponName.replace(
        /\d+/g,
        `<span class="number400">$&</span>`
      )
    },
    effectiveTime() {
      const { couponUseTimeDesc, useStartTimeStr, useEndTimeStr } = this.coupon

      if (!isNullOrEmpty(couponUseTimeDesc))
        return couponUseTimeDesc.replace(/-/g, '.').replace('至', '-')

      return (
        useStartTimeStr.replace(/-/g, '.') +
        '-' +
        useEndTimeStr.replace(/-/g, '.')
      )
    },
    isFinished() {
      const { leftCount } = this.coupon
      return +leftCount <= 0
    },
    /**
     * userGetStatus 用户领取状态 0 未领取 1 已领取
     * userGetLimit 用户领取次数限制 0 不限制
     */
    checkBtnStatus() {
      let {
        userGetLimit = +userGetLimit,
        userGetCount = +userGetCount,
        leftCount
      } = this.coupon
      if (+leftCount <= 0) return false
      return (
        (userGetLimit > 0 && userGetLimit - userGetCount > 0) ||
        userGetLimit === 0
      )
    },
    receivedStatus() {
      return +this.coupon.userGetStatus === COUPON_RECEIVED_STATUS.DONE
    },
    btnText() {
      var str = '领取'
      if (this.receivedStatus) return '继续' + str
      return str
    }
  },
  methods: {
    async getCoupon() {
      const cp = this.coupon
      await this.$$ensureLogin()
      if (cp.userGetLimit > 0 && cp.userGetLimit === cp.userGetCount) {
        this.$$toast('没领到哦，您的单张券已领取达到上限')
        return
      }
      if (this.fetchStatus) {
        return
      }
      this.fetchStatus = true
      const uid = this.$$cookie('uid')
      const skey = this.$$cookie('skey')
      const json = await this.$store.dispatch('userGetCoupon', {
        couponCode: cp.couponCode,
        uid,
        skey
      })
      let { code, data } = json
      code = +code
      if (code === 1) {
        this.coupon = {
          ...cp,
          userGetCount: cp.userGetCount + 1,
          userGetStatus: COUPON_RECEIVED_STATUS.DONE,
          couponPassword: isNonEmptyArray(data) ? data[0] : ''
        }
        this.$$toast('领取成功')
      } else if (code === 4) {
        this.$$login()
      } else {
        if (code === 2004) {
          this.coupon.leftCount = 0
        }
        // console.log(json)
        this.$$toast(json.msg)
      }
      this.fetchStatus = false
    }
  },
  watch: {
    incoupon(n) {
      this.coupon = n
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon-item-w {
  position: relative;
  display: flex;
  align-items: center;
  height: 1.8rem;
  background: #fff3ed;
  overflow: hidden;
  border-radius: 0.16rem;
  &.withoutCType {
    height: 1.6rem;
  }

  .l {
    width: 1.6rem;
    font-size: 0.22rem;
    color: #ff5900;
    text-align: center;
    .price-ctn {
      font-size: 0.52rem;
      // line-height: 0.6rem;
      .tag {
        font-size: 0.3rem;
      }
    }
    margin-right: 0.24rem;
  }
  .m {
    width: 3.68rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // max-height: 1.25rem;
    min-height: 0.9rem;
    font-size: 0.24rem;
    color: #ff5900;
    line-height: 0.28rem;
    &.hideRight {
      flex: 1;
      width: auto;
    }
    .coupon-name {
      font-size: 0.28rem;
      line-height: 0.38rem;
    }
  }
  .r {
    // width: 1.4rem;
    padding-left: 0.06rem;
    padding-right: 0.2rem;
    button {
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // min-width: 1.1rem;
      height: 0.48rem;
      width: 1.24rem;
      line-height: 1;
      font-size: 0.24rem;
      color: #fff;
      background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
      border-radius: 0.24rem;
      // padding: 0 0.14rem;
      padding: 0.14rem 0 0.12rem;
      text-align: center;
    }
    z-index: 10;
  }
}
.c-type {
  position: absolute;
  top: 0;
  left: 0;
  height: 0.32rem;
  line-height: 0.32rem;
  font-size: 0.2rem;
  color: #ff5900;
  text-align: center;
  background: #ffdecc;
  border-radius: 0.16rem 0 0.16rem 0;
  padding: 0 0.24rem;
}

.c-type-b {
  position: absolute;
  top: 0;
  left: 0;
  height: 0.32rem;
  line-height: 0.32rem;
  font-size: 0.2rem;
  color: #481111;
  text-align: center;
  background: #ffddba;
  border-radius: 0.16rem 0 0.16rem 0;
  padding: 0 0.24rem;
}
.img-getted,
.img-snatched {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.28rem;
  height: 1.18rem;
  background-image: url('~@/assets/images/product/new/achived.png');
  background-size: 1.28rem 1.18rem;
  z-index: 1;
}
.img-snatched {
  background-image: url('~@/assets/images/product/new/snatched.png');
}
</style>
